import React from "react"
import { cn } from "../../lib/utils"

export function Card({ className, ...props }) {
  return (
    <div
      className={cn(
        "rounded-xl border border-border/80 bg-card text-card-foreground shadow-sm",
        className,
      )}
      {...props}
    />
  )
}

export function CardHeader({ className, ...props }) {
  return (
    <div
      className={cn(
        "flex flex-col gap-1.5 border-b border-border/60 px-5 pb-4 pt-5 md:px-6 md:pb-5 md:pt-6",
        className,
      )}
      {...props}
    />
  )
}

export function CardTitle({ className, ...props }) {
  return <h3 className={cn("text-base font-semibold leading-none tracking-tight text-foreground", className)} {...props} />
}

export function CardContent({ className, ...props }) {
  return <div className={cn("p-5 pt-5 md:px-6 md:pb-6", className)} {...props} />
}
